import { LinkedService } from '../../model/linkedservice/linkedservice';
import { AzureKeyVault } from '../../model/linkedservice/key-vault';
import { IAttribute, IValidationContext, IViolation } from '../../model/base/annotation';
import { format, sanitizeAndFormatString, stringIsNullOrEmpty, valueIsNullOrEmpty } from './string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { GlobalVariables } from '../../constants/globals';
import { Named } from '../../model/base/named';

export function validateAKVLinkedServiceReference(
    linkedService: LinkedService,
    referencedResource: AzureKeyVault
): IViolation[] | undefined {
    if (linkedService != null && !linkedService.fullyByJsonEditor) {
        if (referencedResource instanceof AzureKeyVault && referencedResource.storageLinkedService == null) {
            return [
                {
                    message: () =>
                        sanitizeAndFormatString(
                            shellStringResources.Error_InvalidLinkedServiceReferenced,
                            linkedService.name,
                            'Azure Key Vault linked service'
                        )
                }
            ];
        }
    }
    return undefined;
}

export function validateNullLinkedServiceReference(
    linkedService: LinkedService,
    referencedResource: LinkedService
): IViolation[] | undefined {
    if (linkedService != null && !linkedService.fullyByJsonEditor) {
        if (referencedResource == null) {
            // referenced other ls invalid
            return [
                {
                    message: () =>
                        sanitizeAndFormatString(
                            shellStringResources.Error_InvalidLinkedServiceReferenced,
                            linkedService.name,
                            'linked service'
                        )
                }
            ];
        }
    }
    return undefined;
}

export function validateLinkedServicePermission(
    linkedService: LinkedService,
    context?: IValidationContext
): IViolation[] {
    if (!GlobalVariables.isTrident || !linkedService) {
        return [];
    }
    if (linkedService.isFakeEntityCreatedFromReference && linkedService.objectId) {
        return [
            {
                message: () =>
                    context?.validateConnectionPermissionOnly
                        ? `${shellStringResources.ConnectionId}: ${linkedService.objectId}`
                        : format(
                              shellStringResources.Error_InvalidResourceReferenceTemplate,
                              shellStringResources.ConnectionLabel.toLocaleLowerCase()
                          ),
                isConnectionPermissionError: true
            }
        ];
    }
    return [];
}

/**
 * In Fabric, if a linked service is parameterized, it means the customer parameterized the whole connection, so we
 * should make sure all properties are filled.
 */
export function validateLinkedServiceProperties(
    linkedService: LinkedService,
    attributes: IAttribute[]
): IViolation[] {
    const violations: IViolation[] = [];
    attributes.forEach((attribute) => {
        if (
            attribute &&
            stringIsNullOrEmpty(attribute.templateValue(linkedService)) &&
            valueIsNullOrEmpty(attribute.value(linkedService))
        ) {
            violations.push({
                message: () => format(shellStringResources.RequiredTemplate, attribute.display),
                redirectTo: {
                    // redirect to the owner of the linked service, not linked service itself
                    entity: linkedService.owner as Named,
                    attribute
                },
                entity: linkedService
            });
        }
    });
    return violations;
}
